<ng-container *ngIf="webhook">
  <details
    #d
    class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-overflow-hidden gw-gatewee-collapsible-details"
  >
    <summary
      class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
    >
      <span class="gw-flex gw-items-center gw-gap-small gw-min-w-0">
        <gatewee-icon
          [icon]="'@tui.send'"
          class="gw-shrink-0 gw-text-text-primary"
        ></gatewee-icon>
        <span class="gw-text-base gw-font-semibold gw-text-text-primary">
          {{ 'common.webhookMetadata.title' | translate }}
        </span>
      </span>
      <span
        class="gw-flex gw-flex-wrap gw-items-center gw-gap-2x-small gw-text-sm gw-text-text-secondary gw-shrink-0"
      >
        <span
          *ngIf="webhook.event"
          class="gw-font-mono gw-truncate gw-max-w-[140px] md:gw-max-w-[220px]"
          >{{ webhook.event }}</span
        >
        <span
          class="gw-badge gw-text-xs"
          [ngClass]="httpStatusBadgeClass(webhook.status)"
        >
          {{ webhook.status }}
        </span>
        <gatewee-expand-chevron
          [expanded]="d.open"
          class="gw-inline-flex gw-text-text-secondary"
        ></gatewee-expand-chevron>
      </span>
    </summary>

    <div class="gw-gatewee-collapsible-panel">
      <div
        class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
      >
        <div
          class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-medium gw-mb-medium"
        >
          <div *ngIf="webhook.event">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.webhookMetadata.event' | translate }}
            </p>
            <p
              class="gw-text-base gw-text-text-primary gw-font-mono gw-break-all"
            >
              {{ webhook.event }}
            </p>
          </div>
          <div>
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.webhookMetadata.sentAt' | translate }}
            </p>
            <p class="gw-text-base gw-text-text-primary">
              {{ webhook.sentAt | date : 'dd/MM/yyyy HH:mm:ss' }}
            </p>
          </div>
          <div>
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.webhookMetadata.status' | translate }}
            </p>
            <span
              class="gw-badge gw-text-sm"
              [ngClass]="httpStatusBadgeClass(webhook.status)"
            >
              {{ webhook.status }}
            </span>
          </div>
          <div>
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.webhookMetadata.retries' | translate }}
            </p>
            <p class="gw-text-base gw-text-text-primary">
              {{ webhook.retries }}
            </p>
          </div>
        </div>

        <div *ngIf="displayWebhookUrl" class="gw-mb-medium">
          <p
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
          >
            {{ 'common.webhookMetadata.webhookUrl' | translate }}
          </p>
          <p
            class="gw-text-sm md:gw-text-base gw-text-text-primary gw-break-all gw-font-mono"
          >
            {{ displayWebhookUrl }}
          </p>
        </div>

        <div class="gw-mb-medium">
          <p
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
          >
            {{ 'common.webhookMetadata.response' | translate }}
          </p>
          <pre
            class="gw-bg-background-elevation-2 gw-p-medium gw-rounded-lg gw-text-xs gw-overflow-x-auto gw-max-h-64 gw-overflow-y-auto gw-text-text-primary gw-font-mono gw-whitespace-pre-wrap gw-break-words"
            >{{ formattedResponse }}</pre
          >
        </div>

        <div>
          <p
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
          >
            {{ 'common.webhookMetadata.headers' | translate }}
          </p>
          <pre
            *ngIf="formattedHeaders; else headersMissing"
            class="gw-bg-background-elevation-2 gw-p-medium gw-rounded-lg gw-text-xs gw-overflow-x-auto gw-max-h-64 gw-overflow-y-auto gw-text-text-primary gw-font-mono gw-whitespace-pre-wrap gw-break-words"
            >{{ formattedHeaders }}</pre
          >
          <ng-template #headersMissing>
            <p class="gw-text-sm gw-text-text-secondary">
              {{ 'common.webhookMetadata.headersUnavailable' | translate }}
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </details>
</ng-container>
